import React from 'react';
import {
  Card, Typography, Box, CardContent, Grid, Divider, ListItem,
} from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import type { IRepairItem } from '../marking/MarkingInterfaces';

const RepairJobContainer: React.FC<{
  repairItem:IRepairItem,
  title: string
}> = ({ repairItem, title }) => {
  const JobMap = (
    repairItem.repairItemJobs?.map((job) => (
      <ListItem style={{ display: 'list-item' }}>
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>{job.jobName}</span>
        {job?.selectedOption ? ` - ${job?.fieldPrompt} - ${job?.selectedOption}` : ''}
        {
          job?.rejected
          && (
          <WarningIcon style={{
            color: 'red', fontSize: '1.5rem', paddingLeft: '5px',
          }}
          />
          )
        }
      </ListItem>
    ))
  );

  return (
    <Card style={{ height: '100%' }}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Box ml={2} my={2}>
            <Typography variant="h5" style={{ fontSize: '1.125rem' }}>{title}</Typography>
          </Box>
        </Grid>
        <Grid item>
          <Box mr={2} mt={2.5}>
            <Typography variant="h5" style={{ fontSize: '.875rem', color: '#A5A5A5', textTransform: 'uppercase' }}>
              {`${repairItem.repairItemJobs && repairItem.repairItemJobs.length > 1
                ? `${repairItem.repairItemJobs.length} Jobs`
                : '1 Job'}`}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Divider />
      <CardContent>
        <Grid
          container
          spacing={2}
        >
          {JobMap}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RepairJobContainer;
